import React from "react";
import "../styles/ServicesSection.css";
import Ellipse1 from '../images/Ellipse 2.png'
import Ellipse2 from '../images/Ellipse 1.png'
import Ellipse3 from '../images/Ellipse 3.png'
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

/* IMAGES */
import techImg from "../../src/images/industries/technology.jpg";
import healthcareImg from "../../src/images/industries/healthcare.jpg";
import financeImg from "../../src/images/industries/finance.jpg";
import retailImg from "../../src/images/industries/retail.jpg";
import educationImg from "../../src/images/industries/education.jpg";
import manufacturingImg from "../../src/images/industries/industries.jpg";

import skilledProfessionals from "../../src/images/why-choose/SKILLED PROFESSIONALS.jpg";
import efficientHiring from "../../src/images/why-choose/EFFICIENT HIRING.jpg";
import adaptability from "../../src/images/why-choose/ADAPTABILITY.jpg";
import commitmentSuccess from "../../src/images/why-choose/COMMITMENT TO SUCCESS.jpg";
import industryExpertise from "../../src/images/why-choose/INDUSTRY EXPERTISE.jpg";
import provenResults from "../../src/images/why-choose/PROVEN RESULTS.jpg";

const features = [
  //   { icon: "👤", title: "Skilled Professionals", desc: "Access to a diverse pool of qualified IT experts." },
  // {
  //   icon: (
  //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
  //       {/* The main rounded box with the centered pin point */}
  //       <path d="M12 21l-1.8-2.4C9.1 17.1 7.3 16.2 5.4 16.2H5c-1.7 0-3-1.3-3-3V5c0-1.7 1.3-3 3-3h14c1.7 0 3 1.3 3 3v8.2c0 1.7-1.3 3-3 3h-0.4c-1.9 0-3.7 0.9-4.8 2.4L12 21z" />

  //       {/* The Person - Head */}
  //       <circle cx="12" cy="7.5" r="2.2" />

  //       {/* The Person - Shoulders */}
  //       <path d="M7.5 13.5c0-2 2-3 4.5-3s4.5 1 4.5 3" />
  //     </svg>
  //   ),
  //   title: "SKILLED PROFESSIONALS", desc: "Access to a diverse pool of qualified IT experts."
  // },
  // {
  //   icon: (
  //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
  //       {/* Top Node and Arrow Path */}
  //       <circle cx="7" cy="7" r="2.5" />
  //       <path d="M17 7h-2.5c-1.1 0-2 .9-2 2v6" />
  //       <path d="M15.5 8.5L17 7l-1.5-1.5" />

  //       {/* Bottom Node and Arrow Path */}
  //       <circle cx="17" cy="17" r="2.5" />
  //       <path d="M7 17h2.5c1.1 0 2-.9 2-2V9" />
  //       <path d="M8.5 15.5L7 17l1.5 1.5" />
  //     </svg>
  //   ),
  //   title: "EFFICIENT HIRING", desc: "Streamlined processes for quick and reliable talent acquisition."
  // },
  // {
  //   icon: (
  //     <svg
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="1.8"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     >
  //       {/* The outer house/structure shape */}
  //       <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />

  //       {/* The upward trending arrow inside */}
  //       <path d="M9 15l2-2 3 3 3-3" />
  //       <path d="M14 13h3v3" />
  //     </svg>
  //   ),
  //   title: "ADAPTABILITY", desc: "Staying ahead of trends to deliver innovative and future-ready solutions."
  // },
  // {
  //   icon: (
  //     <svg
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="1.8"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     >
  //       {/* Top Node */}
  //       <circle cx="12" cy="7" r="2.5" />

  //       {/* Bottom Left Node */}
  //       <circle cx="7.5" cy="15.5" r="2.5" />

  //       {/* Bottom Right Node */}
  //       <circle cx="16.5" cy="15.5" r="2.5" />

  //       {/* Connecting Arcs */}
  //       <path d="M10.2 9.5c-1 1.2-1.5 2.5-1.5 4" />
  //       <path d="M15.3 13.5c0-1.5-.5-2.8-1.5-4" />
  //       <path d="M10.5 16.5h3" />
  //     </svg>
  //   ),
  //   title: "COMMITMENT TO SUCCESS", desc: "Building lasting partnerships for mutual growth and achievement."
  // },
  // {
  //   icon: (
  //     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
  //       {/* Crown base and peaks */}
  //       <path d="M2 18h20L20 7l-4 4-4-7-4 7-4-4L2 18z" />
  //       {/* Decorative horizontal line in middle */}
  //       <line x1="8" y1="14" x2="16" y2="14" />
  //       {/* Bottom base line */}
  //       <line x1="7" y1="21" x2="17" y2="21" />
  //     </svg>
  //   ),
  //   title: "ADAPTABILITY", desc: "Staying ahead of trends to deliver innovative and future-ready solutions."
  // },
  // {
  //   icon: (
  //     <svg
  //       width="24"
  //       height="24"
  //       viewBox="0 0 24 24"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="1.8"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     >
  //       {/* Outer Circle */}
  //       <circle cx="12" cy="12" r="10" />

  //       {/* Person Head */}
  //       <circle cx="12" cy="10" r="3" />

  //       {/* Person Shoulders/Body */}
  //       <path d="M7 18.5c0-2.5 2-4.5 5-4.5s5 2 5 4.5" />
  //     </svg>
  //   ),
  //   title: "INDUSTRY EXPERTISE", desc: "In-depth knowledge across multiple sectors for specialized support."
  // },

  {
    image: skilledProfessionals,
    title: "Skilled Professionals",
    desc: "Our team consists of highly skilled professionals with strong technical knowledge and industry experience."
  },
  {
    image: efficientHiring,
    title: "Efficient Hiring",
    desc: "We streamline the hiring process to connect businesses with the right talent quickly and efficiently."
  },
  {
    image: adaptability,
    title: "Adaptability",
    desc: "We adapt to evolving business needs and provide flexible solutions tailored to each client."
  },
  {
    image: commitmentSuccess,
    title: "Commitment to Success",
    desc: "We are dedicated to delivering results that help our clients and partners achieve long-term success."
  },
  {
    image: industryExpertise,
    title: "Industry Expertise",
    desc: "Our experience across industries enables us to understand unique challenges and deliver effective solutions."
  },
  {
    image: provenResults,
    title: "Proven Results",
    desc: "We have a track record of delivering successful outcomes through reliable strategies and execution."
  }
];

const stats = [
  { value: 100, suffix: "+", label: "SUCCESSFUL IT PROFESSIONALS PLACED IN LEADING ORGANIZATIONS." },
  { value: 50, suffix: "+", label: "BUSINESSES SERVED ACROSS DIVERSE INDUSTRIES." },
  { value: 125, suffix: "+", label: "YEARS EXPERIENCE IN BUSINESS & CONSULTING." },
  { value: 90, suffix: "%", label: "CANDIDATE-CLIENT MATCH SUCCESS RATE." }
];


const industriesData = [
  {
    title: "TECHNOLOGY",
    image: techImg,
    link: "/industries/technology"
  },
  {
    title: "HEALTHCARE",
    image: healthcareImg,
    link: "/industries/healthcare"
  },
  {
    title: "FINANCE",
    image: financeImg,
    link: "/industries/finance"
  },
  {
    title: "RETAIL & E-COMMERCE",
    image: retailImg,
    link: "/industries/retail"
  },
  {
    title: "EDUCATION",
    image: educationImg,
    link: "/industries/education"
  },
  {
    title: "MANUFACTURING",
    image: manufacturingImg,
    link: "/industries/manufacturing"
  }
];


const statsContainer = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.18 }
  }
};

const statsItem = {
  hidden: { opacity: 0, y: 45 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

const ServicesSection = () => {
  const navigate = useNavigate();
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.4
  });

  /* header animation */
  const headerAnim = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] }
    }
  };

  /* avatar pop animation */
  const avatarAnim = {
    hidden: { opacity: 0, scale: 0.6, y: 30 },
    show: i => ({
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        delay: i * 0.15,
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }
    })
  };

  /* grid stagger animation */
  const gridContainer = {
    hidden: {},
    show: {
      transition: { staggerChildren: 0.12, delayChildren: 0.25 }
    }
  };

  /* each card */
  const gridItem = {
    hidden: { opacity: 0, y: 50, scale: 0.95 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] }
    }
  };
  const industryHeader = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.18
      }
    }
  };

  const industryItem = {
    hidden: { opacity: 0, y: 40 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };


  return (
    <section className="services-outer-wrapper py-2">
      {/* 1. PURPLE BOX */}
      <div className="services-purple-container">
        <div className="avatar-group mb-5">
          {[Ellipse1, Ellipse2, Ellipse3].map((img, i) => (
            <motion.div
              key={i}
              custom={i}
              variants={avatarAnim}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className={`avatar-circle ${i === 1 ? "main" : "side"}`}
            >
              <img src={img} alt="Avatar" />
            </motion.div>
          ))}
        </div>


        <div className="services-header">

          <motion.h2 variants={headerAnim} className="industries-badge" style={{ display: 'inline-block' }}>
            WHY CHOOSE US
          </motion.h2>

          <motion.h2
            variants={headerAnim}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            transition={{ delay: 0.15 }}
          >
            GET OUR SERVICES & DRIVE<br />MORE CUSTOMERS.
          </motion.h2>

        </div>


        <motion.div
          className="features-grid"
          variants={gridContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="feature-card"
              variants={gridItem}
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <div className="feature-image">
                <img src={feature.image} alt={feature.title} />
              </div>

              <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>


        {/* Count Section */}
        <section className="py-5" ref={ref}>
          <div className="container">

            <motion.div
              className="row text-center justify-content-center mx-md-5"
              variants={statsContainer}
              initial="hidden"
              animate={inView ? "show" : "hidden"}
            >

              {stats.map((s, i) => (
                <motion.div
                  key={i}
                  className="col-lg-3 col-6 mb-4"
                  variants={statsItem}
                >
                  <div className="stat-item p-md-4">

                    <h2 className="stat-value fw-bold">
                      {inView && (
                        <CountUp
                          start={0}
                          end={parseInt(s.value)}
                          duration={2}
                        />
                      )}
                      {s.suffix}
                    </h2>

                    <div className="stat-line"></div>

                    <p className="stat-label fs-6 text-start">{s.label}</p>

                  </div>
                </motion.div>
              ))}

            </motion.div>

          </div>
        </section>

        <motion.div
          className="industries-purple-header"
          variants={industryHeader}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
        >

          <motion.h2 variants={industryItem} className="industries-badge" style={{ display: 'inline-block' }}>
            SECTORS WE SERVE
          </motion.h2>

          <motion.h2 variants={industryItem}>
            DIVERSE SECTOR <br />EXPERTISE, TAILORED IT SOLUTIONS.
          </motion.h2>

        </motion.div>

      </div>

      {/* 2. WHITE CARD (Placed OUTSIDE so it sits on the light background) */}
      <div className="row justify-content-center w-100">
        <div className="col-9">
          <div className="industries-card-wrapper">

            <button className="nav-btn prev">←</button>

            <Swiper
              modules={[Navigation, Autoplay]}
              navigation={{
                prevEl: ".prev",
                nextEl: ".next",
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
              speed={900}
              spaceBetween={24}
              breakpoints={{
                0: { slidesPerView: 1.2 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                992: { slidesPerView: 4 },
                1200: { slidesPerView: 4 }
              }}
              className="industries-cards"
            >
              {industriesData.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="industry-card" onClick={() => navigate(item.link)}>
                    <div className="img-container">
                      <img src={item.image} alt={item.title} />
                    </div>

                    <div className="industry-card-content">
                      <h3>{item.title}</h3>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <button className="nav-btn next">→</button>

          </div>
        </div>
      </div>


    </section>
  );
};

export default ServicesSection;